export default "__VITE_ASSET__ad3bb44a__"